import expression from "../logic/expression"
import config from "../config"
import tableUtils from "./tableUtils.js"
import logger from "../logger"

const possibleSumColumnNames = config.logic.ads.sumColumns

function preformAnalysis(inputTable, query) {
  if(!inputTable) return null

  const columnsCount = inputTable.columnNames.length
  const columnIdsByName = tableUtils.columnIdsByName(inputTable)
  const sumColumnNames = possibleSumColumnNames.filter(columnName => columnIdsByName.has(columnName))
  const sumColumnInputIds = sumColumnNames.map(columnName => columnIdsByName.get(columnName))
  const sumColumnCount = sumColumnNames.length

  const adColumns = query.aggregateUrls
                  ? config.logic.ads.aggregateColumns.concat(config.logic.ads.urlColumns)
                  : config.logic.ads.aggregateColumns

  const adColumnsNames = adColumns.filter(columnName => columnIdsByName.has(columnName))
  const adColumnsInputIds = adColumnsNames.map(col => columnIdsByName.get(col))

  if(query.categories != 'all') {
    let categories = query.categories
    const categoryColumnsIds = categories.map(col => columnIdsByName.get(col.columnName))

    const prefilteredTable = {
      title: inputTable.title,
      columnNames: inputTable.columnNames.slice(),
      rows: inputTable.rows.filter(row => {
        let match = true
        for(let i = 0; i < categories.length; i++) {
          let value = row[categoryColumnsIds[i]]
          let options = categories[i].options
          match = match && (options.indexOf( value ) != -1)
        }
        return match
      })
    }
    inputTable = prefilteredTable
  }

  let prefilteredData = inputTable.rows
  let preSummaryColumns = adColumnsInputIds.length+1
  let summary = new Array(preSummaryColumns+sumColumnCount)
  for(let i = 0; i < preSummaryColumns; i++) summary[i] = ''
  for(let columnId = 0; columnId < sumColumnCount; columnId++) summary[preSummaryColumns+columnId] = 0
  for(let row of prefilteredData) {
    for(let columnId = 0; columnId < sumColumnCount; columnId++) {
      let v = +row[sumColumnInputIds[columnId]]
      if(isFinite(v)) summary[preSummaryColumns+columnId] += v*100
    }
  }
  summary[0] = 'Summary'

  let adsMap = new Map()
  const adKeyA = new Array(adColumnsInputIds.length)
  const dataRowsCount = inputTable.rows.length
  for(let rowId = 0; rowId < dataRowsCount; rowId++) {
    let row = inputTable.rows[rowId]
    //console.log("ROW", row, wordsColumnInputId)

    let empty = true
    for(let i = 0; i < adColumnsInputIds.length; i++) {
      const colId = adColumnsInputIds[i]
      adKeyA[i] = row[colId]
      if(row[colId] != ' --') empty = false
    }
    if(empty) continue;

    const adKey = adKeyA.join('!@#')

    let accumulator = adsMap.get(adKey)
    if(!accumulator) {
      accumulator = {
        keyColumns: adKeyA.slice(),
        overallCount: 0,
        sumColumns: new Array(sumColumnCount)
      }
      for(let i = 0; i < sumColumnCount; i++) {
        accumulator.sumColumns[i] = 0.0
      }
    }

    for(let i = 0; i < sumColumnCount; i++) {
      accumulator.sumColumns[i] += (row[sumColumnInputIds[i]] * 100)
      /*if(Number.isNaN(accumulator.sumColumns[i])) {
        console.error("VALUE THAT GIVES NAN", row[sumColumnInputIds[i]])
        console.error("IN ROW", row)
        return null
      }*/
    }
    accumulator.overallCount += 100;
    adsMap.set(adKey, accumulator)
  }

  let ads = new Array(adsMap.size)
  let adId = 0
  for (var [adKey, accumulator] of adsMap.entries()) {
    ads[adId++] = accumulator
  }

  if(typeof window != 'undefined') window.out = ads
  return {
    title: "Analiza słów z "+inputTable.title,
    columnNames: adColumnsNames.concat(['Count']).concat(sumColumnNames),
    rows: ads.map(ad => ad.keyColumns.concat([ad.overallCount]).concat(ad.sumColumns)),
    summary: summary
  }
}

function calculateTable(outputTable) {
  if (!outputTable) return null
  let columnNames = outputTable.columnNames
  let columnsCount = columnNames.length
  const columnIdsByName = tableUtils.columnIdsByName(outputTable)

  const outputData = outputTable.rows

  /// CALCULATION:
  const clicksColumnId = columnIdsByName.get("Clicks")
  const impressionsColumnId = columnIdsByName.get("Impressions")
  const costColumnId = columnIdsByName.get("Cost")
  const conversionsColumnId = columnIdsByName.get("Conversions")
  const conversionsValueColumnId = columnIdsByName.get("ConversionValue")

  let calculatedData = outputData
  let summary = outputTable.summary

  if(clicksColumnId !== undefined && impressionsColumnId !== undefined) {
    for(let row of calculatedData) {
      row.push(row[clicksColumnId] * 100 * 100 / row[impressionsColumnId])
    }
    summary.push(summary[clicksColumnId] * 100 * 100 / summary[impressionsColumnId])
    columnNames.push('CTR')
  }

  if(conversionsValueColumnId !== undefined && costColumnId !== undefined) {
    for(let row of calculatedData) {
      row.push(row[conversionsValueColumnId] * 100 / row[costColumnId])
    }
    summary.push(summary[conversionsValueColumnId] * 100 / summary[costColumnId])
    columnNames.push('ROAS')
  }

  if(costColumnId !== undefined && conversionsColumnId !== undefined) {
    for(let row of calculatedData) {
      row.push(row[costColumnId] * 100 / row[conversionsColumnId])
    }
    summary.push(summary[costColumnId] * 100 / summary[conversionsColumnId])
    columnNames.push('CC')
  }

  if(conversionsColumnId !== undefined && clicksColumnId !== undefined) {
    for(let row of calculatedData) {
      row.push(row[conversionsColumnId] * 100 * 100 / row[clicksColumnId])
    }
    summary.push(summary[conversionsColumnId] * 100 * 100 / summary[clicksColumnId])
    columnNames.push('CR')
  }

  for (let columnId = columnsCount; columnId < columnsCount + columnNames.length; columnId++) {
    const columnName = columnNames[columnId]
    columnIdsByName.set(columnName, columnId)
  }
  columnsCount = columnNames.length

  for(let row of calculatedData) {
    for(let cell of row) if(cell == null) throw new Error("null cell "+ JSON.stringify(cell)+ " in row "+ JSON.stringify(row))
  }

  /*for(let row of calculatedData) {
    if(row.length < columnsCount) throw new Error("non normative row!")
    for (let columnId = 8; columnId < columnsCount; columnId++) {
      if (isNaN(row[columnId])) {
        console.log("ROW", row)
        console.log("CTR = ", row[clicksColumnId], '/', row[impressionsColumnId])
        console.log("ROAS = ", row[conversionsValueColumnId], '/', row[costColumnId])
        console.log("CC = ", row[costColumnId], '/', row[conversionsColumnId])
        console.log("ROC = ", row[conversionsColumnId], '/', row[clicksColumnId])
        throw new Error("NAN! " + JSON.stringify(row[columnId]) + " [" + columnId + "] IN " + JSON.stringify(row))
      }
    }
  }*/

  const calculatedTable = {
    title: outputTable.title,
    columnNames: columnNames,
    rows: calculatedData,
    summary: summary
  }
  return calculatedTable
}

function prepareTableView(calculatedTable, viewSettings) {
  if (!calculatedTable) return null
  console.log("PREP VIEW!")
  const calculatedData = calculatedTable.rows

  let columnNames = calculatedTable.columnNames
  let columnsCount = columnNames.length
  let summary = calculatedTable.summary

  /// REMOVING EMPTY COLUMNS
/*  var emptyColumns = []
  for(let colId = 0; colId < columnsCount; colId++) {
    let empty = true;
    for(let row of calculatedData) {
      empty = empty && (Number.isNaN(row[colId]) || row[colId]=='' || row[colId]==Infinity || row[colId]== -Infinity)
    }
    if(empty) emptyColumns.push(colId - emptyColumns.length)
  }
  for(let emptyId of emptyColumns) {
    columnNames.splice(emptyId, 1)
    summary.splice(emptyId, 1)
    for(let row of calculatedData) {
      row.splice(emptyId, 1)
    }
  }*/

  let columnIdsByName = tableUtils.columnIdsByName({columnNames})

  /// FILTERING:
  let filteredData = calculatedData
  if(viewSettings.enableFilter && viewSettings.filter) {
    const filterFunc = expression.compileFilter(viewSettings.filter, columnIdsByName)
    // console.log("COMPILED FILTER", filterFunc)
    filteredData = calculatedData.filter(filterFunc)
  }

  /// SEARCH FILTERING:
  if(viewSettings.searchText != '') filteredData = filteredData.filter(row => {
    let found = false
    for(let cell of row) {
      if(cell.indexOf && cell.toLowerCase().indexOf(viewSettings.searchText.toLowerCase()) != -1) found = true
    }
    return found
  })

  /// Generate objectified ad column
  const adColumnsNames = config.logic.ads.aggregateColumns.concat(config.logic.ads.urlColumns)
    .filter(columnName => columnIdsByName.has(columnName))
  const adTitleNames = config.logic.ads.titleColumns.filter(columnName => columnIdsByName.has(columnName))
  const adTitleIds = adTitleNames.map(col => columnIdsByName.get(col))
  const adText1Names = config.logic.ads.text1Columns.filter(columnName => columnIdsByName.has(columnName))
  const adText2Names = config.logic.ads.text2Columns.filter(columnName => columnIdsByName.has(columnName))
  const adText1Ids = adText1Names.map(col => columnIdsByName.get(col))
  const adText2Ids = adText2Names.map(col => columnIdsByName.get(col))
  const adUrlNames = config.logic.ads.urlColumns.filter(columnName => columnIdsByName.has(columnName))
  const adUrlIds = adUrlNames.map(col => columnIdsByName.get(col))
  const objectifiedData = new Array(filteredData.length)
  for(let rowId = 0; rowId < filteredData.length; rowId++) {
    const row = filteredData[rowId]
    let adObject = {
      title: adTitleIds.map(id => row[id].trim()).filter(t => t.length > 0).filter(t => t != '--').join(' - '),
      text1: adText1Ids.map(id => row[id].trim()).filter(t => t.length > 0).filter(t => t != '--').join('\n'),
      text2: adText2Ids.map(id => row[id].trim()).filter(t => t.length > 0).filter(t => t != '--').join('\n'),
      url: adUrlIds.map(id => row[id].trim()).filter(t => t.length > 0).filter(t => t != '--').join(', ')
    }
    objectifiedData[rowId] = [adObject].concat(row.slice(adColumnsNames.length))
  }
  if(typeof window != 'undefined') window.objd = objectifiedData
  columnNames = ['Ad'].concat(columnNames.slice(adColumnsNames.length))
  summary = ['Summary'].concat(summary.slice(adColumnsNames.length))
  columnIdsByName = tableUtils.columnIdsByName({columnNames})
  columnsCount = columnNames.length

  /// SORTING:
  let sortedData = objectifiedData
  if (objectifiedData.length > 0) {
    sortedData = objectifiedData.slice()
    const sortColumnId = columnIdsByName.get(viewSettings.sortBy)
    //console.log("SORT TABLE", sortedData, "BY", viewSettings.sortBy, sortColumnId)
    if(typeof sortedData[0][sortColumnId] == 'number') {
      if (viewSettings.sortAsc) {
        sortedData.sort((a, b) => a[sortColumnId] - b[sortColumnId])
      } else {
        sortedData.sort((a, b) => b[sortColumnId] - a[sortColumnId])
      }
    } else {
      if (viewSettings.sortAsc) {
        sortedData.sort(
          (a, b) => a[sortColumnId] > b[sortColumnId] ? 1 : (a[sortColumnId] < b[sortColumnId] ? -1 : 0)
        )
      } else {
        sortedData.sort(
          (a, b) => b[sortColumnId] > a[sortColumnId] ? 1 : (b[sortColumnId] < a[sortColumnId] ? -1 : 0)
        )
      }
    }
  }

  /// OUTPUT:
  const sortedTable = {
    title: calculatedTable.title,
    columnNames: columnNames,
    columnTypes: ["ad"].concat(columnNames.slice(1).map(t=>"number")),
    rows: sortedData,
    summary: summary
  }
  return sortedTable
}

function generateTips(inputTable, outputTable, maxTips) {
  const tipsRules = config.adsTips
  let tips = []
  for(let rule of tipsRules) {
    let tip = rule(inputTable, outputTable)
    if(tip) tips.push(tip)
    if(tips.length >= maxTips) return tips
  }
  return tips
}

function findCategories(inputTable) {
  let categories = []
  let rowCount = inputTable.rows
  for(let columnId = 0; columnId < inputTable.columnNames.length; columnId++) {
    let columnName = inputTable.columnNames[columnId]
    if(config.logic.categoryColumns.indexOf(columnName) == -1) continue;
    let categoriesMap = new Map()
    let categoriesCount = 0
    for(let row of inputTable.rows) {
      let categoryName = row[columnId].trim()
      if(categoryName == '') categoryName = "Empty"
      if(categoryName == '--') continue;
      if(!categoriesMap.has(categoryName)) {
        categoriesMap.set(categoryName, true)
        categoriesCount++
      }
    }
    categories.push({
      columnName,
      options: Array.from(categoriesMap.keys())
    })
  }
  return categories
}

const methods = {
  preformAnalysis,
  calculateTable,
  prepareTableView,
  generateTips,
  //findWordsColumn,
  findCategories
}

export default methods;

if(typeof window == "undefined" || window.document === undefined) { // Web Worker Code
  logger.install()
  logger.addWorkerParentLogDestination()
  onmessage = (msg) => {
    let { method, serializedArgs, requestId } = msg.data
    let args = serializedArgs
    //console.log("WORKER CALL", method, args)
    let result = methods[method].apply(null, args)
    //console.log("WORKER RES", result)
    postMessage({
      type: "response",
      result,
      requestId
    })
  }
  postMessage({
    type: "ready"
  })
}




// WEBPACK FOOTER //
// ./src/logic/adsAnalyzer.js